import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService } from 'src/app/core/service/navigation.service';
import { RESPONSE_CODE } from 'src/app/helper/class/app-constant';
import { cloneData, delay, isArray, isEmptyObj, randomLabel } from 'src/app/helper/class/utilityHelper';
import { ResponseData, formBuilder, formBuilderData, tableAction, tableBuilder, tblFilterQuery } from 'src/app/helper/interface/response';
import { dynamicObjectKey } from 'src/app/helper/interface/user';
import { AlertService } from 'src/app/helper/service/alert.service';
import { AuthService } from 'src/app/helper/service/auth.service';
import { AppointmentInfoComponent } from 'src/app/modules/appointment/component/appointment-info/appointment-info.component';
import { APPOINTMENT_LIST } from 'src/app/modules/appointment/helper/appointment-form';
import { AppointmentApiService } from 'src/app/modules/appointment/service/appointment-api.service';
import { InvoiceViewComponent } from 'src/app/modules/invoice/component/invoice-view/invoice-view.component';
import { DOCUMENT_LIST, INVOICE_ADD_LIST, LIST_COL_ALL, LIST_COL_DATA, LIST_TREATMENT_PLAN, PRESCRIPTION_NOTES_LIST, PRESCRIPTION_TABLE_LIST, TREATMENT_PLAN_DATA } from 'src/app/modules/invoice/helper/invoice-form';
import { InvoiceApiService } from 'src/app/modules/invoice/service/invoice-api.service';
import { MasterApiService } from 'src/app/modules/master/service/master-api.service';
import { UserApiService } from 'src/app/modules/user/services/user-api.service';
import { MultiImgDocComponent } from 'src/app/shared/component/multi-img-doc/multi-img-doc.component';
import { DentalChartRefComponent } from 'src/app/shared/feature-modal/dental-chart-ref/dental-chart-ref.component';
import { SendMsgComponent } from 'src/app/shared/feature-modal/send-msg/send-msg.component';
import { TabHeadComponent } from 'src/app/shared/feature-modal/tab-head/tab-head.component';
import { DynamicTableFormComponent } from 'src/app/shared/form/component/dynamic-table-form/dynamic-table-form.component';
import { FormGeneratorComponent } from 'src/app/shared/form/component/form-generator/form-generator.component';
import { TableListComponent } from 'src/app/shared/form/component/table-list/table-list.component';
import { confirmModalData } from 'src/app/shared/interface/modal-interface';
import { ModalService } from 'src/app/shared/service/modal.service';
import { DENTAL_TABLE_LIST, NEW_INVESTIGATION, NEW_INVESTIGATION_TABLE, PATIENT_DETAIL, PRESCRIPTION_COL } from '../../helper/patient-form';
import { PatientsService } from '../../service/patients.service';
import { AddPatientComponent } from '../add-patient/add-patient.component';
import { DentalChartComponent } from '../dental-chart/dental-chart.component';
import { UrlServices } from 'src/app/helper/class/url-services';
import { PrintDocComponent } from 'src/app/shared/feature-modal/print-doc/print-doc.component';
import { DELETE_REMARKS_FORM } from 'src/app/core/helper/core_form_helper';
import { AddAppointmentComponent } from 'src/app/modules/appointment/component/add-appointment/add-appointment.component';
import { PAYMENT_LIST } from 'src/app/modules/payments/helper/helper';
import { PaymentsService } from 'src/app/modules/payments/services/payments.service';
import { PrescriptionInfoComponent } from '../prescription-info/prescription-info.component';
import { Confirmation } from 'primeng/api';
import { PaymentsInfoComponent } from 'src/app/modules/payments/payments-info/payments-info.component';

@Component({
  selector: 'app-patient-treatment-details',
  templateUrl: './patient-treatment-details.component.html',
  styleUrls: ['./patient-treatment-details.component.scss']
})
export class PatientTreatmentDetailsComponent implements OnInit, AfterViewInit {
  teethbutton: boolean = false;
  patient_info: any = PATIENT_DETAIL
  appointFormData: formBuilder[] = [
    { colName: 'doctor_fk_id', title: 'Doctor Name', type: 'select', apiTblName: 'doctor', selectKeyName: 'fname', selectPrimaryKey: 'user_id', event: { name: 'change', isCallback: true } }
  ];

  segment = {
    SUMMARY: 'Summary',
    INVESTIGATION: 'Investigation',
    CHART: 'Dental Chart',
    TREATMENT_PLAN: 'Treatment Plan',
    TREATMENT: 'Treatment',
    PRESCRIPTION: 'Prescription',
    APPOINTMENT: 'Appointment',
    INVOICE: 'Invoice',
    // FILES: 'Files',
    PAYMENT: 'Payment'
  }
  currentSegment: any = this.segment.TREATMENT;
  type: 'ROUTINE' | 'VIEW' = 'VIEW'
  investigationFormData = cloneData(NEW_INVESTIGATION);
  presTempformData: formBuilder[] = [
    { colName: 'pres_temp', title: 'Prescription Set', type: 'select', selectKeyName: 'tempName' }
  ]
  appointTableConfig: tableBuilder = {
    name: '',
    action: [
      { name: '', type: 'VIEW', class: 'bg-orange', icon: 'las la-eye', title: 'View Appointment' },
      { name: '', type: 'EDIT', class: 'bg-danger', icon: 'las la-times-circle', title: 'Reschedule' },
      // { name: '', type: 'APPROVE', class: 'bg-success', icon: 'las la-check-circle', title: 'Make as active' }
    ],
    isLazy: true,
    column: cloneData(APPOINTMENT_LIST),
    showFilter: false
  }
  invesTableConfig: tableBuilder = {
    name: '',
    action: [
      { name: '', class: 'btn-info', icon: 'las la-pencil-alt', title: 'Edit', type: 'EDIT' },
      { name: '', icon: 'las la-trash', type: 'INACTIVE', title: 'Remove', class: 'btn-danger' }
    ],
    isLazy: true,
    column: cloneData(NEW_INVESTIGATION_TABLE),
  }
  chartTableConfig: tableBuilder = {
    name: '',
    action: [
      // { name: '', class: 'btn-info', icon: 'las la-pencil-alt', title: 'Edit', type: 'EDIT' },
      { name: '', icon: 'las la-trash', type: 'DELETE', title: 'Remove', class: 'btn-danger' }
    ],
    column: DENTAL_TABLE_LIST,
    isLazy: true
  }
  invoiceTableConfig: tableBuilder = {
    name: 'Invoice Table',
    action: [{ name: '', type: 'VIEW', class: 'bg-orange', icon: 'las la-eye', title: 'View Invoice' },
    { name: '', type: 'EDIT', class: 'btn btn-info', icon: 'las la-pencil-alt', title: 'Edit Invoice', condition: [{ key: 'status', value: 1, operation: '!=' }] },
    { name: '', class: 'btn-danger', icon: 'las la-trash', title: 'Delete', type: 'DELETE', },
    { name: '', class: 'btn-primary', icon: 'las la-print', title: 'Print', type: 'PRINT' },
    ],
    headerAction: [
      { name: '', class: 'table-icon-btn-primary', icon: 'las la-print', title: 'Print Selected', type: 'PRINT' },
    ],
    isLazy: true,
    column: cloneData(LIST_COL_ALL),
  };
  paymentTableConfig: tableBuilder = {
    name: 'Payment Table',
    action: [
      { name: '', type: 'VIEW', class: 'bg-orange', icon: 'las la-eye', title: 'View Payment' },
      { name: '', class: 'btn-primary', icon: 'las la-print', title: 'Print', type: 'PRINT' },
    ],
    isLazy: true,
    column: cloneData(PAYMENT_LIST),
  };
  selectedTooth: any[] = []
  selectedTreatmentToothNumbers: string[] = [];
  treatmentList: any[] = [];
  treatTblConfig: tableBuilder = {
    name: 'treatment list',
    column: cloneData(LIST_COL_DATA),
    action: [
      { name: '', class: 'btn-primary', icon: 'las la-print', title: 'Print', type: 'PRINT' },
      { name: '', class: 'btn-info', icon: 'las la-pencil-alt', title: 'Edit', type: 'EDIT' },
      { name: '', class: 'btn-danger', icon: 'las la-trash', title: 'Delete', type: 'DELETE', }
    ],
    isLazy: true,
    showFilter: false,
  };
  treatPlanTblConfig: tableBuilder = {
    name: 'treatment Plan list',
    column: cloneData(LIST_TREATMENT_PLAN),
    action: [
      { name: '', class: 'btn-primary', icon: 'las la-print', title: 'Print', type: 'PRINT' },
      { name: '', class: 'btn-info', icon: 'las la-pencil-alt', title: 'Edit', type: 'EDIT' },
      { name: '', class: 'btn-danger', icon: 'las la-trash', title: 'Delete', type: 'DELETE', },
    ],
    isLazy: true,
    showFilter: false,
  };

  prescriptionTableConfig: tableBuilder = {
    name: 'Prescription List',
    column: cloneData(PRESCRIPTION_TABLE_LIST),
    action: [
      { name: '', class: 'bg-orange', icon: 'las la-eye', title: 'View', type: 'VIEW', },
      // { name: '', class: 'btn-info', icon: 'las la-pencil-alt', title: 'Edit', type: 'EDIT' },
      { name: '', class: 'btn-danger', icon: 'las la-trash', title: 'Delete', type: 'DELETE', },
      { name: '', class: 'btn-primary', icon: 'las la-print', title: 'Print', type: 'PRINT' },
    ],
    isLazy: true,
    showFilter: false
  }

  patientData: any = {};
  medicalHistory: any = [];
  treatmentPlanList: any = [];
  treatmentPlanFormData: formBuilderData[] = cloneData(TREATMENT_PLAN_DATA);
  treatmentFormData: formBuilderData[] = cloneData(INVOICE_ADD_LIST);
  documentFormData: formBuilderData[] = cloneData(DOCUMENT_LIST);
  prescriptionNotesFormData: formBuilderData[] = cloneData(PRESCRIPTION_NOTES_LIST);
  prescripFormData: formBuilder[] = cloneData(PRESCRIPTION_COL);
  virtualScrollData: any[] = [{ label: 'test1', doctorName: 'Dr.test', treat: 'Checkup' }, { label: 'test2', doctorName: 'Dr.test', treat: 'Checkup' }, { label: 'test3', doctorName: 'Dr.test', treat: 'Checkup' },];
  vitrualCol: any[] = [{ name: 'label', type: 'label' }, { name: 'doctorName', icon: 'las la-pencil-alt' }, { name: 'treat' }];
  @ViewChild('investigationForm') investigationForm: FormGeneratorComponent | undefined;
  @ViewChild('treatmentform') treatmentform: FormGeneratorComponent | undefined;
  @ViewChild('treatmentPlanForm') treatmentPlanForm: FormGeneratorComponent | undefined;
  @ViewChild('documentForm') documentForm: FormGeneratorComponent | undefined;
  @ViewChild('prescriptionNotesForm') prescriptionNotesForm: FormGeneratorComponent | undefined;
  @ViewChild('treatmentDoctor') treatmentDoctor: FormGeneratorComponent | undefined;
  @ViewChild('treatmentTbl') treatmentTbl: TableListComponent | undefined;
  @ViewChild('treatmentPlanTbl') treatmentPlanTbl: TableListComponent | undefined;
  @ViewChild('invoiceTableList') invoiceTableList: TableListComponent | undefined;
  @ViewChild('dentalChartRef') dentalChartRef: DentalChartComponent | undefined;
  @ViewChild('prescriptionDynamic') prescriptionDynamic: DynamicTableFormComponent | undefined;
  @ViewChild('historyTbl') historyTbl: TableListComponent | undefined;
  @ViewChild('tab') tab: TabHeadComponent | undefined;
  @ViewChild('imgDoc') image_doc: MultiImgDocComponent | undefined
  patientId;
  dataLoading: boolean = false;
  prescritionCtrl = new FormControl('')
  prescriptionTemplateData: any[] = [];
  precsriData: any = [];
  showPrescHistory: boolean = false;
  lastestPrescHistory: any = []
  userData: any = {};
  patientInvestigationData: any = {}
  invoiceList: any;
  selectedInvoiceData: any[] = [];
  invoiceSelectionEnabled: boolean = false;
  currentInvestigationId: any
  currentTreatmentPlanId: any
  currentTreatmentId: any
  toothNumber: any
  appointmentData: any;
  constructor(
    private activateRoute: ActivatedRoute,
    private modalService: ModalService,
    private appointmentApi: AppointmentApiService,
    private patientApi: PatientsService,
    private alertService: AlertService,
    private router: Router,
    private masterApi: MasterApiService,
    private userApi: UserApiService,
    private invoiceApi: InvoiceApiService,
    private navServe: NavigationService,
    private auth: AuthService,
    private paymentApi: PaymentsService,
  ) { }

  // ngOnInit(): void {
  //   this.activateRoute.queryParams.subscribe((params: any) => {
  //     this.initPage();
  //   });
  //   this.userData = this.auth.currentUserValue;
  //   const dytabletaken = this.prescriptionDynamic?.apiPayload() || []
  // }

  ngOnInit(): void {
    this.activateRoute.queryParams.subscribe((params: any) => {
      const newId = params['id'];
      const newType = params['type'] || 'VIEW';
      if (newId !== this.patientId || newType !== this.type) {
        this.initPage();
      }
    });
    this.userData = this.auth.currentUserValue;
    const dytabletaken = this.prescriptionDynamic?.apiPayload() || []
  }

  ngAfterViewInit(): void {
    this.applySavedTreatmentDoctor();
  }

  initPage() {
    this.patientId = this.activateRoute.snapshot.queryParams['id'];
    this.type = this.activateRoute.snapshot.queryParams['type'] || 'VIEW';
    this.setSavedTreatmentDoctorDefault();
    // if (this.type == 'ROUTINE') {
    // this.segment = { ...{ SUMMARY: 'Summary' }, ...this.segment }
    // }
    this.getPatientData();
    this.getPrescriptionTemplate();
    this.getPresciptionData();
  }

  get treatmentDoctorStorageKey(): string {
    return `patient-treatment-doctor-${this.patientId || 'new'}`;
  }

  saveTreatmentDoctorSelection(doctorId: any) {
    if (doctorId !== undefined && doctorId !== null && doctorId !== '') {
      localStorage.setItem(this.treatmentDoctorStorageKey, doctorId.toString());
      this.setSavedTreatmentDoctorDefault();
    }
  }

  setSavedTreatmentDoctorDefault() {
    const doctorId = localStorage.getItem(this.treatmentDoctorStorageKey);
    if (!doctorId) {
      return;
    }

    this.treatmentFormData = this.treatmentFormData.map((field: formBuilderData) => {
      if (field.colName === 'doctor_fk_id') {
        return { ...field, defaultValue: doctorId };
      }
      return field;
    });
  }

  applySavedTreatmentDoctor() {
    setTimeout(() => {
      if (this.currentTreatmentId || !this.treatmentform) {
        return;
      }

      const doctorId = localStorage.getItem(this.treatmentDoctorStorageKey);
      if (doctorId) {
        this.treatmentform.patchValue({ doctor_fk_id: doctorId });
      }
    });
  }

  investigationTableAction = (id: string | number, type: tableAction, data: any) => {
    console.log('tbl action', data)
    switch (type) {
      case 'EDIT':
        this.currentInvestigationId = id;
        console.log('edit id', id);

        this.investigationForm?.setData(data);
        break;
      case 'INACTIVE':
        this.confirmDelete('Confirm Delete Investigation', 'Are you sure you want to delete this investigation?', () => {
          this.deleteInvestigation(id);
        });
        break;
    }
  }

  treatmentTableAction = (id: string | number, type: tableAction, data: any) => {
    console.log('tbl action', type, 'id', id, data)
    switch (type) {
      case 'EDIT':
        this.currentTreatmentId = id
        this.treatmentform?.setData(this.normalizeTreatmentEditData(data))
        this.setSelectedTreatmentToothNumbers(data);
        this.currentTreatmentSelectionId = data?.treatment_fk_id || data?.treatmentId || '';
        this.selected_treatment = this.getTreatmentById(this.currentTreatmentSelectionId);
        this.teethbutton = !!+this.selected_treatment?.is_chart;
        console.log('treatmentPlanData', this.treatmentform);
        break;
      case 'DELETE':
        this.confirmDelete('Confirm Delete Treatment', 'Are you sure you want to delete this treatment?', () => {
          this.deleteTreatment(id);
        });
        break;
      case 'PRINT':
        this.printTreatment(id)
        break;
    }
  }

  prescriptionTableAction = (id: string | number, type: tableAction, data: any) => {
    console.log('tbl action', type, 'id', id, data)
    switch (type) {
      case 'VIEW':
        this.modalService.openModal(PrescriptionInfoComponent, data, 'model-xl')
        break;
      case 'DELETE':
        this.confirmDelete('Confirm Delete Prescription', 'Are you sure you want to delete this prescription?', () => {
          this.deletePrescriptionById(id, data);
        });
        break
      case 'PRINT':
        this.printPatientPrescription(id)
        break;
    }
  }

  check(ev: any) {
    console.log('tab change', ev);

  }

  tblAction = async (id: string | number, type: tableAction, data: any, index): Promise<any> => {
    console.log('tbl action', type, 'id', id, data)
    if (!this.tab) {
      await delay(500)
    }
    const activeSeg = this.tab?.getCurrentSegment();
    switch (type) {
      case 'EDIT':
        switch (activeSeg) {
          case this.segment.TREATMENT_PLAN:
            this.currentTreatmentPlanId = id;
            this.treatmentPlanForm?.setData(data);
            break;
          case this.segment.INVOICE:
            this.router.navigate([UrlServices.PAGE_URL.INVOICE.PAYMENTVIEW.URL], { queryParams: { id: id, mode: 'EDIT' } })
            break
          case this.segment.APPOINTMENT:
            this.rescheduleAppointment(data)
            break;
        }
        break;
      case 'DELETE':
        switch (activeSeg) {
          case this.segment.TREATMENT_PLAN:
            this.confirmDelete('Confirm Delete Treatment Plan', 'Are you sure you want to delete this treatment plan?', () => {
              this.deleteTreatmentPlan(id);
            });
            break;
          case this.segment.INVOICE:
            this.confirmDelete('Confirm Delete Invoice', 'Are you sure you want to delete this invoice?', () => {
              this.deleteInvoice(id);
            });
            break;
          case this.segment.CHART:
            this.confirmDelete('Confirm Delete Dental Chart', 'Are you sure you want to delete this dental chart?', () => {
              this.deleteDentalChart(id);
            });
            break;
        }
        break;
      case 'VIEW':
        switch (activeSeg) {
          case this.segment.APPOINTMENT:
            this.modalService.openModal(AppointmentInfoComponent, data, 'modal-lg')
            break;
          case this.segment.INVOICE:
            this.modalService.openModal(InvoiceViewComponent, { id: data.id, mode: 'VIEW' }, 'modal-lg')
            console.log('id', id);
            break;
          case this.segment.PAYMENT:
            this.modalService.openModal(PaymentsInfoComponent, data, 'modal-lg')
            break;
          default:
            break;
        }
        break;
      case 'APPROVE':
        switch (activeSeg) {
          case this.segment.APPOINTMENT:
            // this.markAsComplete(data)
            break;
        }
        break;
      case 'PRINT':
        switch (activeSeg) {
          case this.segment.TREATMENT_PLAN:
            this.printTreatmentPlan(id)
            break;
          case this.segment.INVOICE:
            if (!id && Array.isArray(data)) {
              this.printSelectedInvoice(data);
            } else {
              this.printInvoice(id)
            }
            break;
          case this.segment.PAYMENT:
            this.printPayment(id)
            break;
        }
    }
    return Promise.resolve(true);
  }
  selected_treatment: any = ''
  treatmentToothUnitAmount = 0;
  currentTreatmentSelectionId: any = '';

  normalizeTreatmentEditData(data: any) {
    const treatmentData = cloneData(data);
    const consultationDate = this.parseConsultationDate(treatmentData?.consultation_date);

    if (treatmentData?.doctor_fk_id !== undefined && treatmentData?.doctor_fk_id !== null) {
      treatmentData.doctor_fk_id = treatmentData.doctor_fk_id.toString();
    }

    if (treatmentData?.treatment_fk_id !== undefined && treatmentData?.treatment_fk_id !== null) {
      treatmentData.treatment_fk_id = treatmentData.treatment_fk_id.toString();
    }

    if (consultationDate) {
      treatmentData.consultation_date = consultationDate;
    } else {
      delete treatmentData.consultation_date;
    }

    return treatmentData;
  }

  parseConsultationDate(dateValue: any): string {
    if (!dateValue || dateValue === '0000-00-00') {
      return '';
    }

    if (dateValue instanceof Date && !isNaN(dateValue.getTime())) {
      return dateValue.toISOString().slice(0, 10);
    }

    const dateText = String(dateValue).trim();
    const isoDate = dateText.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
    if (isoDate) {
      const [, year, month, day] = isoDate;
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    const slashDate = dateText.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
    if (slashDate) {
      const [, day, month, year] = slashDate;
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    const parsedDate = new Date(dateText);
    return isNaN(parsedDate.getTime()) ? '' : parsedDate.toISOString().slice(0, 10);
  }

  removeSelectedTreatmentTooth(index: number) {
    this.selectedTreatmentToothNumbers.splice(index, 1);
    this.toothNumber = this.selectedTreatmentToothNumbers.join(',');
    this.selectedTooth = this.selectedTooth.filter((_, toothIndex) => toothIndex !== index);

    const amountPerTooth = this.treatmentToothUnitAmount || Number(this.selected_treatment?.amount) || 0;
    if (amountPerTooth) {
      const qty = this.selectedTreatmentToothNumbers.length;
      this.treatmentform?.patchValue({ amount: String(amountPerTooth * qty) });
    }
  }

  setSelectedTreatmentToothNumbers(data: any) {
    const toothNumbers = this.getTreatmentToothNumbers(data);
    this.selectedTreatmentToothNumbers = toothNumbers;
    this.toothNumber = toothNumbers.join(',');
    this.selectedTooth = toothNumbers.map(toothNumber => ({ toothNumber }));
    this.treatmentToothUnitAmount = this.getTreatmentToothUnitAmount(data, toothNumbers.length);
  }

  getTreatmentToothNumbers(data: any): string[] {
    if (!data) {
      return [];
    }

    const source = data.teeth_number || data.add_toothName || data.toothNumber || data.tooth;

    if (Array.isArray(source)) {
      return source
        .map(tooth => typeof tooth === 'object' ? tooth?.toothNumber || tooth?.teeth_number : tooth)
        .filter(toothNumber => toothNumber !== undefined && toothNumber !== null && toothNumber !== '')
        .map(toothNumber => toothNumber.toString());
    }

    if (source) {
      return source
        .toString()
        .split(',')
        .map(toothNumber => toothNumber.trim())
        .filter(toothNumber => toothNumber);
    }

    return [];
  }

  getTreatmentToothUnitAmount(data: any, toothCount: number): number {
    const treatmentId = data?.treatment_fk_id || data?.treatmentId;
    const treatment = this.getTreatmentById(treatmentId);
    const treatmentAmount = Number(treatment?.amount);

    if (treatmentAmount) {
      return treatmentAmount;
    }

    const totalAmount = Number(data?.amount) || 0;
    return toothCount ? totalAmount / toothCount : totalAmount;
  }

  getTreatmentById(treatmentId: any) {
    const allTreatment = this.treatmentform?.FORM_SUPPORT_DATA?.['treatment_fk_id'] || [];
    return allTreatment.find(a => a.id == treatmentId) || '';
  }

  clearSelectedTreatmentTeeth() {
    this.selectedTreatmentToothNumbers = [];
    this.selectedTooth = [];
    this.toothNumber = '';
  }

  treatmentSelected(event) {
    if (event.controlName == 'treatment_fk_id') {
      this.teethbutton = false;
      const val = event.value;
      const treatmentChanged = !!this.currentTreatmentSelectionId && this.currentTreatmentSelectionId != val;

      if (treatmentChanged) {
        this.clearSelectedTreatmentTeeth();
      }

      this.selected_treatment = '';
      if (val) {
        this.currentTreatmentSelectionId = val;
        this.selected_treatment = this.getTreatmentById(val);
        this.treatmentToothUnitAmount = Number(this.selected_treatment?.amount) || 0;
        const payload = this.treatmentPlanForm?.apiPayload() || {};
        payload.amount = this.selected_treatment?.amount;
        this.treatmentPlanForm?.patchValue(payload);
        const treatmentPayload = this.treatmentform?.apiPayload() || {};
        treatmentPayload.amount = this.selected_treatment?.amount
        this.treatmentform?.patchValue(treatmentPayload)
      }

      if (+this.selected_treatment?.is_chart) {
        this.teethbutton = true;
        this.openToothModal(this.selected_treatment);
      } else {
        const s = { tooth: [], remarks: '', treatment: this.selected_treatment, amount: this.selected_treatment?.amount };
        this.addTreatment(s);
      }
    }
  }

  rescheduleAppointment(eventData: any) {
    const data: any = { ...eventData, type: 'RESCHEDULE' };
    this.modalService.openModal(AddAppointmentComponent, data, 'modal-lg').then((res) => {
      if (res) {
        //update this appointment data;
        this.appointmentData?.todays_data?.map(a => {
          if (a.id === data.id) {
            a = res
          } return a
        })
        this.appointmentData?.upcoming_data?.map(a => {
          if (a.id === data.id) {
            a = res
          } return a
        })
      }
    })
  }

  markAsComplete(data: any) {
    const config: Confirmation = {
      message: 'Are you sure you want to mark as complete?',
    };

    this.appointmentData = data;  // Set appointmentData instead of appointFormData

    this.modalService.openConfirmDialog(config).then((res: boolean) => {
      if (res) {
        console.log('appointmentData', this.appointmentData);  // Now this will log correctly
        const [{ id }] = this.appointmentData.todays_data;
        console.log('Patient ID:', id);

        this.userApi.markAsComplete(id, this.appointmentData).then((res: ResponseData) => {
          if (res.statusCode === RESPONSE_CODE.SUCCESS) {
            console.log('Mark as completed response:', res);
            this.alertService.showToast('Mark as completed', 'success');
          }
        });
      }
    });
  }

  confirmDelete(title: string, message: string, onConfirm: () => void) {
    const config: confirmModalData = {
      title,
      message,
      btnOK: 'Yes',
      btnCancel: 'No',
      isFormField: false
    };

    this.modalService.openConfirmDialog(config).then((res: boolean) => {
      if (res) {
        onConfirm();
      }
    }).catch(() => { });
  }


  getInvestigationPayload() {
    const investigationData = this.investigationForm?.getFormValue() || {};

    const payload: any = {
      patient_fk_id: this.patientId,
      created_by: this.userData?.user_id || this.auth.currentUserValue.user_id,
      ...investigationData
    };

    if (this.currentInvestigationId) {
      payload.id = this.currentInvestigationId;
    }

    delete payload.created_byName;
    delete payload.created_at;

    return payload;
  }

  investigationSave() {
    this.investigationForm?.setSubmitted(true);
    if (!this.investigationForm?.isValid()) {
      this.alertService.showToast('Fill the required Fields', 'info');
      return;
    }

    this.dataLoading = true;
    const payload = this.getInvestigationPayload();
    this.patientApi.saveInvestigation(payload).then((res: ResponseData) => {
      if (res.statusCode === RESPONSE_CODE.SUCCESS) {
        this.patientInvestigationData = res.result;
        console.log('patientInvestigationData', this.patientInvestigationData);
        this.alertService.showToast('Investigation saved', 'success');
        this.currentInvestigationId = null;
        this.investigationForm?.reset();
        this.investigationForm?.setSubmitted(false);
      }
    }).finally(() => this.dataLoading = false);
  }

  deleteInvestigation(id: any) {
    this.dataLoading = true;
    this.patientApi.deleteInvestigation(id, {}).then((res: ResponseData) => {
      if (res.statusCode == RESPONSE_CODE.SUCCESS) {
        this.alertService.showToast('Investigation Deleted', 'success');
        if (this.currentInvestigationId == id) {
          this.currentInvestigationId = null;
          this.investigationForm?.reset();
          this.investigationForm?.setSubmitted(false);
        }
      }
    }).finally(() => this.dataLoading = false);
  }

  deletePrescriptionById(id: any, data: any) {
    console.log('data', data);

    this.dataLoading = true
    this.patientApi.deletePrescriptionById(id, this.getPrescriptionPayload()).then((res: ResponseData) => {
      if (res.statusCode === RESPONSE_CODE.SUCCESS) {
        this.alertService.showToast('Prescription Deleted', 'success');
      }
    }).finally(() => this.dataLoading = false)
  }

  deleteTreatment(id: any) {
    this.dataLoading = true
    this.patientApi.deleteTreatmentById(id, this.treatmentPayload()).then((res: ResponseData) => {
      if (res.statusCode === RESPONSE_CODE.SUCCESS) {
        this.alertService.showToast('Treatment  Deleted', 'success')
      }
    }).finally(() => this.dataLoading = false)
  }

  deleteTreatmentPlan(id: any) {
    this.dataLoading = true;
    this.patientApi.deleteTreatmentPlanById(id, this.treatmentPlanPayload()).then((res: ResponseData) => {
      if (res.statusCode == RESPONSE_CODE.SUCCESS) {
        this.alertService.showToast('Treatment Plan Deleted', 'success');
      }
    }).finally(() => this.dataLoading = false);
  }

  deleteInvoice(id: any) {
    this.dataLoading = true;
    this.invoiceApi.deleteInvoiceById(id, {}).then((res: ResponseData) => {
      if (res.statusCode === RESPONSE_CODE.SUCCESS) {
        this.alertService.showToast('Invoice Deleted', 'success')
      }
    }).finally(() => this.dataLoading = false)

  }

  deleteDentalChart(id: any) {
    this.dataLoading = true
    this.patientApi.deleteDentalChartById(id, {}).then((res: ResponseData) => {
      if (res.statusCode === RESPONSE_CODE.SUCCESS) {
        this.alertService.showToast('Dental Chart Examination Deleted', 'success')
      }
    }).finally(() => this.dataLoading = false)
  }

  treatmentPlanPayload() {
    const treatmentPlanData = this.treatmentPlanForm?.getFormValue() || {};
    console.log('treatmentPlanData', treatmentPlanData);

    let teethNumberValue = '';
    const teethData = this.toothNumber;
    console.log('Using this.toothNumber for payload:', teethData);
    if (Array.isArray(teethData) && teethData.length > 0) {
      teethNumberValue = teethData.join(',');
    } else if (typeof teethData === 'string' && teethData.trim() !== '') {
      teethNumberValue = teethData;
    }

    const payload: any = {
      patient_fk_id: this.patientId?.toString() || '',
      created_by: (this.userData?.user_id || this.auth.currentUserValue.user_id)?.toString() || '',
      treatment_fk_id: (treatmentPlanData.treatmentId || treatmentPlanData.treatment_fk_id || '').toString(),
      teeth_number: teethNumberValue,
      amount: treatmentPlanData.amount?.toString() || '',
      notes: treatmentPlanData.notes || '',
    };

    if (this.currentTreatmentPlanId) {
      payload.id = this.currentTreatmentPlanId;
    }

    console.log('treatment plan payload', payload);
    return payload;
  }


  treatmentPlanSave() {
    this.treatmentPlanForm?.setSubmitted(true);
    if (!this.treatmentPlanForm?.isValid()) {
      this.alertService.showToast('Fill the required Fields', 'info');
      return;
    }

    this.dataLoading = true;
    const payload = this.treatmentPlanPayload();
    this.patientApi.saveTreatmentPlan(payload).then((res: ResponseData) => {
      if (res.statusCode === RESPONSE_CODE.SUCCESS) {
        this.alertService.showToast('Treatment Plan saved', 'success');
      }
    }).finally(() => this.dataLoading = false);
  }

  getListData = async (e: tblFilterQuery): Promise<any> => {
    let API: any = {};
    e.page = e.page ?? 0;
    e.rows = e.rows || 10;
    e.queryParams = e.queryParams || [];
    e.whereField = e.whereField ? e.whereField : [];
    if (!this.tab) {
      await delay(500)
    }
    const activeSeg = this.tab?.getCurrentSegment();
    switch (activeSeg) {
      case this.segment.APPOINTMENT:
        e.whereField = [...e.whereField, ...[{ colName: 'patient_fk_id', value: this.patientId }]]
        API = this.appointmentApi.getList(e);
        break;
      case this.segment.INVOICE:
        e.whereField = [...e.whereField, ...[{ colName: 'patient_fk_id', value: this.patientId }]]
        API = this.invoiceApi.getList(e);
        break;
      case this.segment.INVESTIGATION:
        e.whereField = [...e.whereField, ...[{ colName: 'patient_fk_id', value: this.patientId }, { colName: 'status', value: 1 }]]
        API = this.patientApi.patientInvestigationList(e);
        break;
      case this.segment.PRESCRIPTION:
        e.whereField = [...e.whereField, ...[{ colName: 'patient_fk_id', value: this.patientId }, { colName: 'status', value: 1 }]]
        API = this.patientApi.patientPrescriptionList(e);
        break;
      case this.segment.TREATMENT_PLAN:
        e.whereField = [...e.whereField, ...[{ colName: 'patient_fk_id', value: this.patientId }, { colName: 'status', value: 1 }]]
        API = this.patientApi.getListTreatmentPlanByPatient(e);
        break;
      case this.segment.TREATMENT:
        e.whereField = [...e.whereField, ...[{ colName: 'patient_fk_id', value: this.patientId }, { colName: 'status', value: 1 }]]
        API = this.patientApi.patientTreatmentList(e)
        break;
      case this.segment.PAYMENT:
        e.whereField = [...e.whereField, ...[{ colName: 'patient_fk_id', value: this.patientId }]]
        API = this.paymentApi.getList(e);
        break;
      case this.segment.CHART:
        e.whereField = [...e.whereField, ...[{ colName: 'patient_fk_id', value: this.patientId }, { colName: 'status', value: 1 }]]
        API = this.patientApi.patientDentalChartList(e)
        break;
    }
    if (isEmptyObj(API)) {
      return;
    }
    return await API.then((res: ResponseData) => {
      if (res.statusCode == RESPONSE_CODE.SUCCESS) {
        res.result.data.map((a: any) => {
          // a.status == 1 ? a.statusName = 'Available' : 'Unavailable'
          return a
        })
      }
      return res
    })
  }

  getPrescriptionTemplate() {
    if (this.patientId) {
      this.dataLoading = true;
      this.masterApi.prescriptionLists().then((res: ResponseData) => {
        if (res.statusCode == RESPONSE_CODE.SUCCESS) {
          this.prescriptionTemplateData = res.result;
        }
      }).finally(() => this.dataLoading = false)
    }
  }
  fillPrescriptionFromTemplate(selectedItems: any[]) {
    if (Array.isArray(selectedItems)) {
      const itemsToSet = selectedItems.flatMap(item => {
        const transformedItem = item.item?.map((value) => {
          value.isTemplate = true;
          delete value.id;
          return value
        });
        return transformedItem;
      });
      let existData = this.prescriptionDynamic?.apiPayload() || [];
      existData = existData.filter(data => !data?.isTemplate);
      const newData = [...existData, ...itemsToSet];
      this.prescriptionDynamic?.setInputData(newData);
      this.prescriptionDynamic?.reset();
    }
  }


  getPatientData() {
    if (this.patientId) {
      this.dataLoading = true;
      this.patientApi.getDetails(this.patientId).then((res: ResponseData) => {
        if (res.statusCode == RESPONSE_CODE.SUCCESS) {
          this.patientData = res.result;

          const adr: any = [];
          Object.keys(this.patientData).forEach((a: any) => {
            if (['address', 'cityName', 'stateName'].includes(a) && this.patientData[a]) {
              adr.push(this.patientData[a]);
            }
          })
          this.patientData.full_address = adr.join(',');
          this.medicalHistory = this.patientData.medical_history?.map((a) => a.illnessName);
        }
      }).finally(() => this.dataLoading = false)
    }
  }

  hasUnsavedChanges(): boolean {
    const payload = this.getApiPayload();
    if ((payload?.treatment?.length || 0) > 0 || (payload?.prescription?.length || 0) > 0) {
      return true;
    }
    return false;
  }

  showExitConfirmation(): Promise<boolean> {
    return new Promise((resolve) => {
      this.modalService.openConfirmDialog({
        title: 'Unsaved Changes',
        message: 'You have unsaved changes. Do you want to save them before leaving?',
        isFormField: false
      }).then((res) => {
        if (!res) {
          resolve(true);
          return;
        }

        this.modalService.openConfirmDialog({
          isFormField: true,
          title: 'Make Complete visits',
          message: 'Are you sure want to do this ?',
          formField: [
            {
              colName: 'appointment_on',
              title: 'Next Appointment',
              type: 'DATETIME',
              showTime: true,
              stepMinute: 10
            },
            {
              colName: 'appointment_for',
              title: 'Appointment for'
            }
          ]
        }).then((formRes) => {
          if (!formRes) {
            resolve(true);
            return;
          }
          this.submitFormWhenRouting(formRes).then((isSaved: boolean) => {
            if (isSaved) {
              resolve(true);
            } else {
              resolve(false);
            }
          });

        }).catch(() => resolve(false));
      }).catch(() => resolve(false));
    });
  }

  confirmSubmit() {
    //   // check any data entered
    if (this.getValidation() == false) {
      return this.alertService.showToast('Please fill Treatment or prescription')
    }
    this.modalService.openConfirmDialog({
      title: 'Schedule Next Appointment',
      message: 'Do you want to schedule next appointment?',
      isFormField: false
    }).then((res) => {
      if (res) {
        this.modalService.openConfirmDialog({
          isFormField: true, title: 'Make Complete visits', message: 'Are you sure want to do this ?', formField: [{
            colName: 'appointment_on', title: 'Next Appointment', type: 'DATETIME', showTime: true,
            stepMinute: 10
          }, { colName: 'appointment_for', title: 'Appointment for' }]
        }).then(res => {
          if (res) {
            this.submitForm(res);
          }
          console.log('confirmSubmit   result ', res)
        })
      } else {
        this.submitForm(res)
      }
    });
  }

  navigateToNewPayment() {
    this.router.navigate([UrlServices.PAGE_URL.PAYMENTS.ADD.URL]);
  }

  getPrescriptionPayload() {
    const prescriptionPayload = this.prescriptionNotesForm?.getFormValue();
    // prescriptionPayload.items = this.prescriptionDynamic?.apiPayload() || [];
    const items = this.prescriptionDynamic?.apiPayload() || [];
    console.log('sdsds', this.prescriptionDynamic);

    prescriptionPayload.items = items.map(item => ({ action: 1, medicine: item.medicineName, m_type: item.medicine_typeName, frequency: item.medicine_frequencyName, dosage: item.medicine_dosageName, duration: item.medicine_durationName, notes: item.notes }));
    prescriptionPayload.created_by = this.userData.user_id;
    prescriptionPayload.patient_fk_id = this.patientId;
    console.log('prescription payload', prescriptionPayload);

    return prescriptionPayload;
  }


  getDocumentPayload() {
    const DocumentPayload = this.documentForm?.getFormValue()
    DocumentPayload.patient_fk_id = this.patientId
    return DocumentPayload
  }


  getApiPayload() {
    console.log('hii');
    console.log('image doc', this.image_doc);

    const payload: any = {
      patient_fk_id: this.patientId,
      id: this.patientId
    };

    const treatmentPlanList = this.treatmentPlanList || [];
    if (treatmentPlanList.length > 0) {
      const firstPlan = treatmentPlanList[0];
      if (firstPlan.consultation_date) {
        payload.consultation_date = firstPlan.consultation_date;
      }
    }

    payload.investigation = this.investigationForm?.getFormValue();
    payload.treatment = this.treatmentList || [];

    if (payload.treatment.length) {
      let { doctor_fk_id } = this.treatmentDoctor?.apiPayload() || {};
      if (!doctor_fk_id) {
        doctor_fk_id = this.auth.currentUserValue.user_id;
      }
      payload.treatment = payload.treatment.map(a => {
        a.doctor_fk_id = doctor_fk_id;
        return a;
      });
    }

    payload.examination = this.dentalChartRef?.getPayload();

    payload.prescription = this.prescriptionDynamic?.apiPayload();
    payload.treatment_plan = treatmentPlanList;

    console.log('payload treatment plan', payload.treatment_plan);

    payload.doc = this.image_doc?.apiPayload();

    return payload;
  }


  getValidation() {
    const payload = this.getApiPayload();
    if (!isArray(payload.treatment)) {
      return false;
    }
    return true;
  }
  loading: boolean = false;
  submitForm(appointmentData) {
    const pay = this.getApiPayload();
    this.loading = true;
    const payload = { ...pay, ...appointmentData }
    this.patientApi.savePatientRoutine(payload).then((res: ResponseData) => {
      if (res.statusCode == RESPONSE_CODE.SUCCESS) {
        this.alertService.showToast('Successfully Saved', 'success');
        window.location.reload();
        this.router.navigate([UrlServices.PAGE_URL.PATIENT.LIST.URL])
        // this.router.navigate(['patient/list']);
      }
    }).finally(() => this.loading = false)
  }

  submitFormWhenRouting(appointmentData: any): Promise<boolean> {
    return new Promise((resolve) => {
      const payload = this.getApiPayload();
      const apiPayload = { ...payload, ...appointmentData };
      this.loading = true;

      this.patientApi.savePatientRoutine(apiPayload).then((res: ResponseData) => {
        if (res.statusCode === RESPONSE_CODE.SUCCESS) {
          this.alertService.showToast('Successfully Saved', 'success');
          resolve(true);
        } else {
          this.alertService.showToast('Save failed', 'error');
          resolve(false);
        }
      }).catch(() => {
        this.alertService.showToast('Save failed', 'error');
        resolve(false);
      }).finally(() => {
        this.loading = false;
      });
    });
  }

  openToothModal(treatment = {}) {
    const selectedTeeth = this.selectedTreatmentToothNumbers.map(toothNumber => ({ toothNumber }));
    this.modalService
      .openModal(DentalChartRefComponent, { selectedTeeth }, 'modal-lg', 1)
      .then((res: any) => {
        console.log('Tooth modal result:', res);
        if (!res) {
          return;
        }

        if (Array.isArray(res.tooth) && res.tooth.length) {
          this.selectedTooth = res.tooth;
          this.selectedTreatmentToothNumbers = res.tooth
            .map(tooth => tooth?.toothNumber)
            .filter(toothNumber => toothNumber !== undefined && toothNumber !== null && toothNumber !== '')
            .map(toothNumber => toothNumber.toString());

          this.toothNumber = res.tooth
            .map(tooth => tooth.toothNumber)
            .join(',');

          console.log('Selected teeth numbers string:', this.toothNumber);

          this.treatmentPlanForm?.patchValue({
            teeth_number: this.toothNumber
          });
        }

        res.treatment = treatment;

        const qty = res.tooth?.length || 1;
        const amountPerTooth = Number(res.treatment?.amount) || 0;
        this.treatmentToothUnitAmount = amountPerTooth;
        const totalAmount = amountPerTooth * qty;

        console.log(`Selected ${qty} teeth → amount per tooth = ${amountPerTooth}, total = ${totalAmount}`);

        res.amount = totalAmount;

        this.addTreatment(res);

        if (this.segment.TREATMENT_PLAN === this.tab?.getCurrentSegment()) {
          this.treatmentPlanForm?.patchValue({ amount: String(totalAmount) });
        } else if (this.segment.TREATMENT === this.tab?.getCurrentSegment()) {
          this.treatmentform?.patchValue({ amount: String(totalAmount) });
        }
        // this.treatmentPlanForm?.patchValue({ amount: String(totalAmount) });

      });
  }


  addTreatment(toothForm: any = { tooth: [], remarks: '', treatment: {} }) {
    const activeSeg = this.tab?.getCurrentSegment(),
      formName: 'treatmentform' | 'treatmentPlanForm' = activeSeg == this.segment.TREATMENT_PLAN ? 'treatmentPlanForm' : 'treatmentform',
      treatmentVar: 'treatmentList' | 'treatmentPlanList' = activeSeg == this.segment.TREATMENT_PLAN ? 'treatmentPlanList' : 'treatmentList',
      tblName: 'treatmentTbl' | 'treatmentPlanTbl' = activeSeg == this.segment.TREATMENT_PLAN ? 'treatmentPlanTbl' : 'treatmentTbl';
    if (!this[formName]?.isValid()) return;
    const val = cloneData(this[formName]?.getFormValue()),
      d: any = cloneData(val);
    d.amount = d.amount || this.selected_treatment?.amount;
    d.add_tooth = cloneData(toothForm.tooth);
    d.add_toothName = d.add_tooth.map(a => a.toothNumber)?.toString();
    d.treatmentName = d.add_toothName ? `${d.treatmentName} (${d.add_toothName})` : d.treatmentName
    d.description = d.add_tooth ? `(${d.add_toothName})` : this.selected_treatment.description || '';
    this.selectedTooth = [];
    d.status = 1; //mark completed
    //cal total Amount
    if (activeSeg == this.segment.TREATMENT_PLAN) {
      d.notes = toothForm.remarks;
    } else {
      d.patient_treatment_stepName = toothForm.remarks || '';
      if (toothForm.remarks) {
        d.status = 2; //In progress
      }
      const qty = d?.add_tooth?.length || 1;
      d.amount = (this.selected_treatment?.amount || 0) * (qty > 1 ? qty : 1);
    }
    if (activeSeg == this.segment.TREATMENT_PLAN && d.add_tooth.length) {
      d.add_tooth.forEach((e: any) => {
        const s = cloneData(d);
        s.add_tooth = [e];
        s.add_toothName = e?.toothNumber;
        s.teeth_number = e.toothNumber;
        s.status = 2;
        s.treatmentName = s.add_toothName ? `${val.treatmentName} (${s.add_toothName})` : val.treatmentName
        this[treatmentVar].push(s)
      });
    } else
      this[treatmentVar].push(d);
    // this[formName]?.reset();
    this[formName]?.patchValue({ amount: this.selected_treatment?.amount });
    // this[tblName]?.reload();
    this.teethbutton = false;
    this.selected_treatment = '';
  }

  get randomlabel() {
    return randomLabel()
  }

  treatmentPayload() {
    const treatmentData = this.treatmentform?.getFormValue() || {};
    // console.log('treatmentPlanData', this.treatmentform);
    let teethNumberValue = '';
    const teethData = this.toothNumber;
    console.log('Using this.toothNumber for payload:', teethData);
    if (Array.isArray(teethData) && teethData.length > 0) {
      teethNumberValue = teethData.join(',');
    } else if (typeof teethData === 'string' && teethData.trim() !== '') {
      teethNumberValue = teethData;
    }

    const payload: any = {
      patient_fk_id: this.patientId?.toString() || '',
      doctor_fk_id: (treatmentData.doctor_fk_id || this.userData?.doctor_id || this.auth.currentUserValue.user_id)?.toString() || '',
      amount: treatmentData.amount?.toString() || '0',
      treatment_fk_id: (treatmentData.treatmentId || treatmentData.treatment_fk_id || '').toString(),
      remarks: treatmentData.notes || treatmentData.remarks || '',
      teeth_number: teethNumberValue,
      consultation_date: treatmentData.consultation_date || new Date().toISOString().slice(0, 10), // yyyy-mm-dd
      created_by: (this.userData?.user_id || this.auth.currentUserValue.user_id)?.toString() || '',
    };

    if (this.currentTreatmentId) {
      payload.id = this.currentTreatmentId;
      payload.invoice_fk_id = this.treatmentform?.apiData?.invoice_fk_id
      payload.invoice_item_fk_id = this.treatmentform?.apiData?.invoice_item_fk_id
    }
    console.log('treatment payload', payload);
    return payload;
  }


  treatmentSave() {
    if (!this.treatmentform?.isValid()) {
      this.alertService.showToast('Fill the required Fields', 'info');
      return;
    }
    const payload = this.treatmentPayload()
    this.patientApi.PatientTreatmentSave(payload).then((res: ResponseData) => {
      console.log('treatment res', res)
      if (res.statusCode === RESPONSE_CODE.SUCCESS) {
        this.saveTreatmentDoctorSelection(payload.doctor_fk_id);
        this.applySavedTreatmentDoctor();
        this.alertService.showToast('Treatment saved', 'success');
        window.location.reload();
      }
    })
  }

  prescriptionSave() {
    if (!this.prescriptionNotesForm?.isValid()) {
      this.alertService.showToast('Fill the required Fields', 'info');
      return;
    }
    // if (!this.prescriptionDynamic) {
    //   this.alertService.showToast('Fill the required Fields', 'info');
    //   return;
    // }
    this.patientApi.PatientPrescriptionSave(this.getPrescriptionPayload()).then((res: ResponseData) => {
      if (res.statusCode == RESPONSE_CODE.SUCCESS) {
        this.alertService.showToast('Successfully Saved', 'success');
        this.prescriptionNotesForm?.reset();
        this.prescriptionDynamic?.reset();
        window.location.reload();
      } else {
        this.alertService.showToast('Unable to save', 'error')
      }
    })

  }

  documentSave() {
    // if (!this.documentForm?.isValid()) {
    //   this.alertService.showToast('Fill the required Fields', 'info');
    //   return;
    // }
    this.patientApi.PatientDocumentSave(this.getDocumentPayload()).then((res: ResponseData) => {
      if (res.statusCode == RESPONSE_CODE.SUCCESS) {
        this.alertService.showToast('Successfully Saved', 'success');
        this.documentForm?.reset();
      } else {
        this.alertService.showToast('Unable to save', 'error')
      }
    })
  }

  genToken() {
    if (!this.patientId) {
      return;
    }
    const modalData: confirmModalData = { type: 'FORM', isFormField: true, formField: [{ colName: 'doctor_fk_id', title: 'Doctor Name', type: 'select', apiTblName: 'doctor', selectKeyName: 'fname', selectPrimaryKey: 'user_id', validator: [{ name: 'required' }] },] }
    this.modalService.openConfirmDialog(modalData).then((r) => {
      if (r) {
        const docId = r?.['doctor_fk_id']
        this.userApi.genToken(this.patientId, docId).then((res: ResponseData) => {
          if (res.statusCode == RESPONSE_CODE.SUCCESS) {
            this.alertService.showToast('Token Generate Successfully', 'success')
          }
        })
      }
    })

  }

  printIdCard() {
    const p: any = { eventName: 'PATIENT_CARD', id: this.patientId };
    this.modalService.openModal(PrintDocComponent, p, 'modal-lg', 2)
  }

  printPrescription(data) {
    const p: any = { eventName: 'PRESCRIPTION', id: data.id };
    this.modalService.openModal(PrintDocComponent, p, 'modal-lg', 2)
  }

  printTreatmentPlan(id: any) {
    this.loading = true;
    this.patientApi.treatmentPlanPrint(id).then((res: ResponseData) => {
      if (res.statusCode === RESPONSE_CODE.SUCCESS) {
        const treatmentPlanHtml = res.result?.html;
        const modalData: any = {
          eventName: 'TREATMENT_PLAN',
          id: id,
          htmlContent: treatmentPlanHtml,
        };
        this.modalService.openModal(PrintDocComponent, modalData, 'modal-lg', 2);
      }
    }).finally(() => {
      this.loading = false;
    });
  }

  printTreatment(id: any) {
    this.loading = true;
    this.patientApi.treatmentPrint(id).then((res: ResponseData) => {
      if (res.statusCode === RESPONSE_CODE.SUCCESS) {
        const treatmentHtml = res.result?.html;

        const modalData: any = {
          eventName: 'TREATMENT',
          id: id,
          htmlContent: treatmentHtml,
        };
        this.modalService.openModal(PrintDocComponent, modalData, 'modal-lg', 2);
      }
    }).finally(() => {
      this.loading = false;
    });
  }

  printPatientPrescription(id: any) {
    this.loading = true;

    this.patientApi.patientPrescriptionPrint(id).then((res: ResponseData) => {
      if (res.statusCode === RESPONSE_CODE.SUCCESS) {
        const prescriptionHtml = res.result?.html;

        const modalData: any = {
          eventName: 'PRESCRIPTION',
          id: id,
          htmlContent: prescriptionHtml,
        };

        this.modalService.openModal(PrintDocComponent, modalData, 'modal-lg', 2);
      }
    }).finally(() => {
      this.loading = false;
    });
  }

  printInvoice(id: any) {
    this.loading = true;
    this.patientApi.patientInvoicePrint(id).then((res: ResponseData) => {
      if (res.statusCode === RESPONSE_CODE.SUCCESS) {
        const invoiceHtml = res.result?.html;

        const modalData: any = {
          eventName: 'INVOICE',
          id: id,
          htmlContent: invoiceHtml
        };

        this.modalService.openModal(PrintDocComponent, modalData, 'modal-lg', 2);
      }
    }).finally(() => {
      this.loading = false;
    });
  }

  onInvoiceSelect(data: any[]) {
    this.selectedInvoiceData = Array.isArray(data) ? data : [];
  }

  toggleInvoiceSelection(event: any) {
    this.invoiceSelectionEnabled = event?.target?.checked || false;
    if (!this.invoiceSelectionEnabled) {
      this.selectedInvoiceData = [];
      this.invoiceTableList?.clearAllSelection();
    }
  }

  printSelectedInvoice(data: any[] = this.selectedInvoiceData) {
    if (!this.invoiceSelectionEnabled) {
      this.alertService.showToast('Please enable invoice selection to print selected invoices', 'info');
      return;
    }

    const invoiceIds = (data || [])
      .map((invoice: any) => invoice?.id || invoice?.invoice_fk_id)
      .filter((id: any) => id !== undefined && id !== null && id !== '');

    if (!invoiceIds.length) {
      this.alertService.showToast('Please select invoice to print', 'info');
      return;
    }

    const payload = { id: invoiceIds };

    this.loading = true;
    this.patientApi.patientInvoiceBulkPrint(payload).then((res: ResponseData) => {
      if (res.statusCode === RESPONSE_CODE.SUCCESS) {
        const invoiceHtml = res.result?.html;

        const modalData: any = {
          eventName: 'INVOICE',
          id: invoiceIds,
          htmlContent: invoiceHtml
        };

        this.modalService.openModal(PrintDocComponent, modalData, 'modal-lg', 2);
      }
    }).finally(() => {
      this.loading = false;
    });
  }

  printPayment(id: any) {
    this.loading = true;
    this.patientApi.patientPaymentPrint(id).then((res: ResponseData) => {
      if (res.statusCode === RESPONSE_CODE.SUCCESS) {
        const paymentHtml = res.result?.html;

        const modalData: any = {
          eventName: 'PAYMENT',
          id: id,
          htmlContent: paymentHtml,
        };

        this.modalService.openModal(PrintDocComponent, modalData, 'modal-lg', 2);
      }
    }).finally(() => {
      this.loading = false;
    });
  }

  getPresciptionData() {
    if (!this.patientId) {
      return
    }
    this.patientApi.getPatientPrescriptionHistory(this.patientId).then((res: ResponseData) => {
      if (res.statusCode == RESPONSE_CODE.SUCCESS) {
        this.precsriData = res?.result;
      }
    })
  }

  getTreatHistoryList = (ev: tblFilterQuery) => {
    ev.whereField = [...ev.whereField || [], ...[{ colName: 'patient_fk_id', value: this.patientId }]]
    return this.patientApi.getListTreatmentByPatient(ev);
  }

  getPrescHistoryList = (ev: tblFilterQuery) => {
    ev.whereField = [...ev.whereField || [], ...[{ colName: 'patient_fk_id', value: this.patientId }]]
    return this.patientApi.getListPrescritionByPatient(ev).then((res: ResponseData) => {
      if (res.statusCode == RESPONSE_CODE.SUCCESS) {
        res?.result?.data.map((a, i) => {
          if (i < 6) {
            this.lastestPrescHistory.push(a);
          }
          a.item.map((b) => { b.randomColor = this.randomlabel; return b })
          return a
        })
      }
      return res
    });
  }
  openEditPatientModal() {
    if (!this.patientId) {
      return
    }
    const data = { id: this.patientId }
    this.modalService.openModal(AddPatientComponent, data, 'modal-xl', 2, false).then((res) => {

    })
  }
  whatsappMsg(data) {
    const d = { mobile_no: data };
    this.modalService.openModal(SendMsgComponent, d, 'modal-md');
  }

  deletePrescription(id) {
    this.modalService.openConfirmDialog({ title: 'Confirm Delete Prescription', isFormField: true, formField: DELETE_REMARKS_FORM }).then(res => {
      if (res) {
        this.patientApi.deletePrescription(id, res).then((result: any) => {
          if (result.statusCode == RESPONSE_CODE.SUCCESS) {
            const index = this.lastestPrescHistory.findIndex(a => a.id == id);
            this.lastestPrescHistory?.splice(index, 1);
            this.alertService.showToast('Successfully deleted prescription!', 'success');
          }
        })
      }
    }).catch(() => { });

  }

  addAppointment(data: any) {
    data.patient_fk_id = this.patientId
    data.appointment_on = new Date();
    this.modalService.openModal(AddAppointmentComponent, data, 'modal-lg');
  }

  openInvoiceModal(id) {
    this.modalService.openModal(InvoiceViewComponent, { patient_fk_id: id, mode: 'EDIT' }, 'modal-xl')
      .then((res: any) => {
        if (res.reload) {
          this.invoiceDetails();
        }
      });
  }

  invoiceDetails() {
    this.loading = true;
    this.invoiceApi.invoiceDetails().then((a: any) => {
      this.invoiceList = a.result;
    }).finally(() => this.loading = false);

  }
}
